export default {
  authenticated () {
    return this.$store.getters.authenticated
  },

  toolbarHeight () {
    return this.$vuetify.breakpoint.smAndDown
      ? 56
      : 64
  },

  cs () {
    return this.$store.state.cs
  },

  formAppBarHeight () {
    return this.$store.getters.formAppBarHeight
  },

  formAppBarHeightDense () {
    return this.$store.getters.formAppBarHeightDense
  },

  apiUrl () {
    return this.$store.state.apiBaseUrl + '' + this.$store.state.tenant;
  },

  items () {
    return this.$store.getters['moduleListItems'][this.moduleName]
  },

  modules () {
    return this.$store.getters['modules']
  },

  adminTopLinks () {
    return this.$store.getters.adminTopLinks
  },

  selectedModuleName: {
    get () {
      return this.$store.state.selectedModuleName
    },
    set (value) {
      this.$store.state.selectedModuleName = value
    }
  },

  innerHeight: {
    get () {
      return this.$store.state.innerHeight
    },
    set (value) {
      this.$store.state.innerHeight = value
    }
  },

  searchClosedMobileMainList: {
    get () {
      return this.$store.state.searchClosedMobileMainList
    },
    set (value) {
      this.$store.state.searchClosedMobileMainList = value
    }
  },

  innerWidth: {
    get () {
      return this.$store.state.innerWidth
    },
    set (value) {
      this.$store.state.innerWidth = value
    }
  },

  showSnackbar: {
    get () {
      return this.$store.getters.showSnackbar
    },
    set (value) {
      this.$store.state.showSnackbar = value
    }
  },

  showMenu: {
    get () {
      return this.$store.state.showMenu
    },
    set (value) {
      this.$store.state.showMenu = value
    }
  },

  showRightMenu: {
    get () {
      return this.$store.state.showRightMenu
    },
    set (value) {
      this.$store.state.showRightMenu = value
    }
  },

  snackbarTimeout () {
    return this.$store.getters.snackbarTimeout
  },

  snackbarColor () {
    return this.$store.getters.snackbarColor
  },

  snackbarText () {
    return this.$store.getters.snackbarText
  },

  user () {
    return this.$store.getters.user
  },

  modulesLoaded () {
    return this.$store.getters.modulesLoaded
  },

  linkItems () {
    return this.$store.getters.moduleListLinkItems[this.moduleName]
  },

  linkItemsCount () {
    return this.$store.getters.moduleListLinkItemsCount[this.moduleName]
  },

  translations () {
    return this.$store.getters['translations']
  },

  contentLanguages () {
    return this.$store.getters['contentLanguages']
  },

  units () {
    return this.$store.getters['moduleListItems']['units']
  },

  registeredModules () {
    return this.$store.getters['moduleListItems']['modules']
  },

  menuGroups () {
    return this.$store.getters['moduleListItems']['menuGroups']
  },

  language () {
    return this.$store.getters['language']
  },

  editAttributes () {
    return this.$store.getters.ac.can('current').updateAny(this.moduleName).attributes
  },

  readAttributes () {
    return this.$store.getters.ac.can('current').readAny(this.moduleName).attributes
  },

  sortedFields () {
    let fields = []
    Object.keys(this.module.fields).forEach(fieldName => {
      fields.push(this.module.fields[fieldName])
    })
    fields.sort((a, b) => parseInt(a.sortOrder) < parseInt(b.sortOrder) ? -1 : 1)
    return fields
  },

  fieldsArrayFromModule () {
    let fields = []
    this.sortedFields.forEach(field => {
        fields.push({
        fieldName: field.fieldName,
        info: this.module.fields[field.fieldName],
        canEdit: this.editAttributes.includes(field.fieldName) ||
          (this.editAttributes.includes('*') && !this.editAttributes.includes('!' + field.fieldName)),
        canRead: this.readAttributes.includes(field.fieldName) ||
          (this.readAttributes.includes('*') && !this.readAttributes.includes('!' + field.fieldName))

        })
      })
    return fields
  }
}
